import {
    Card,
    CardContent,
    IconButton,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import UserRole from '../../../../shared/AuthRoles';
import { CustomButton } from '../../../../layout/styledcomponents/CustomButton';
import { Message } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import {
    useCreateJobChatMutation,
    useJoinJobChannelMutation,
} from '../../../../app/Slices/SevenDayApiSlice';
import toast from '../../../shared/Toast';
import { JoinJobChannel } from '../../../../app/Slices/SevenDayApiTypes';

interface ContactFormProps {
    /** job id */
    id: number;
    channelId?: string;
}

const ContactForm = ({ id, channelId }: ContactFormProps) => {
    /**
     *
     * Using react state for this form as it is already contained within another FormProvider.
     *
     */
    const loggedInUser = UserRole();
    const navigate = useNavigate();

    const [createChannel] = useCreateJobChatMutation();
    const [joinChannel] = useJoinJobChannelMutation();
    const [message, setMessage] = useState('');
    const [messageSending, setMessageSending] = useState(false);

    const handleSend = async () => {
        try {
            setMessageSending(true);
            const response = await createChannel({
                message,
                jobId: id,
            }).unwrap();
            navigate(`/messages/${response?.channelId}`);
        } catch {
            toast.error('Error sending message');
        } finally {
            setMessageSending(false);
        }
    };

    const onNavigate = async () => {
        try {
            const body: JoinJobChannel = {
                jobId: id,
            };

            await joinChannel(body).unwrap();

            navigate(`/messages/${channelId}`);
        } catch {
            toast.error('Error joining channel');
        }
    };

    return (
        <Card variant='outlined'>
            <CardContent>
                <Stack spacing={1}>
                    <Typography sx={{ fontWeight: 'bold' }}>
                        Message{' '}
                        {loggedInUser?.role.includes('contractor')
                            ? 'Host'
                            : 'Contractor'}
                    </Typography>
                    {channelId ? (
                        <Typography>
                            You have an existing chat with this{' '}
                            {loggedInUser?.role.includes('contractor')
                                ? 'host'
                                : 'contractor'}
                            <IconButton color='primary' onClick={onNavigate}>
                                <Message />
                            </IconButton>
                        </Typography>
                    ) : (
                        <>
                            <TextField
                                size='small'
                                fullWidth
                                multiline
                                rows={2}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder='Enter your message here...'
                                inputProps={{
                                    maxLength: 5000,
                                    'aria-label': loggedInUser?.role.includes(
                                        'contractor',
                                    )
                                        ? 'Message to host'
                                        : 'Message to contractor',
                                }}
                            />
                            <div>
                                <CustomButton
                                    variant='contained'
                                    color='primary'
                                    disabled={message === '' || messageSending}
                                    onClick={handleSend}
                                    loading={messageSending}
                                >
                                    Send Message
                                </CustomButton>
                            </div>
                        </>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};

export default ContactForm;
